import { API_URL, Status } from '../constants';
import { fetch } from '../fetchWrapper/fetch';
import { ICreateTimetableRequestBody, ITimetable } from './types';

export const createTimetables = async (requestBody: ICreateTimetableRequestBody): Promise<ITimetable> => {
  try {
    const response = await fetch(`${API_URL}/timetables`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestBody),
    });

    const json = await response.json();

    if (response.status !== Status.CREATED) {
      const hasErrorMsg = !!json && typeof json === 'object' && 'message' in json && typeof json.message === 'string';
      throw new Error(hasErrorMsg ? json.message : 'Could not create timetable');
    }

    return json.data[0];
  } catch (error) {
    throw error instanceof Error ? error : new Error('Unknown failure');
  }
};
